import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Fragment, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { styled, useTheme } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useI18N } from '../../context/I18NContext';
import { useSettings } from '../../context/SettingsContext';
import { useFlow } from '../../context/FlowContext';
import useWidgetStore from '../../store/useWidgetStore';
import useDataStore from '../../store/useDataStore';
import { isDesktop, isMobile } from '../../../../helpers/browser';
import ConfigHolder from '../../config/ConfigHolder';
import NumberSpinnerField from '../fields/NumberSpinnerField';
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import { useNavigate } from 'react-router-dom';
import { moneyFormat } from '../../helpers/general';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    // verticalAlign: 'top',
    textAlign: 'right',
    width: '6em'
}));
export default function CartSimple(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const { t, ts } = useI18N();
    const theme = useTheme();
    const flow = useFlow();
    const { enabled, setEnabled, cart, setCart, booking, language, selectedCapacity, selectedCapacityGroups } = useWidgetStore();
    const { apptypes, resources, products, setProducts, getProduct } = useDataStore();
    const { showSelectedResource, staticData, orientation, multipleAppointments } = useSettings();
    const navigate = useNavigate();
    const [hasDeletables, setHasDeletables] = useState(false);
    const [oldLines, setOldLines] = useState([]);
    const [apptypeImage, setApptypeImage] = useState();
    const [apptypeStr, setApptypeStr] = useState();
    const [resourceStr, setResourceStr] = useState();
    const [capacityStr, setCapacityStr] = useState();
    const [totalPriceStr, setTotalPriceStr] = useState();
    const [invoiceTotal, setInvoiceTotal] = useState(0);
    const [date, setDate] = useState();
    const [smallMode, setSmallMode] = useState(false);
    useEffect(() => {
        if (!enabled.product) {
            setEnabled(Object.assign(Object.assign({}, enabled), { product: true }));
        }
        setSmallMode(orientation === "vertical" || isMobile);
    }, []);
    useEffect(() => {
        var _a, _b;
        if (((_a = booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let appointment = booking.appointments[0];
            setDate(dayjs(appointment.date).locale(language).format('dddd D MMMM HH:mm'));
            let component = appointment.components[0];
            let _apptypes = [];
            let _resources = [];
            component.resources.forEach((resource_id) => {
                let resource = staticData === null || staticData === void 0 ? void 0 : staticData.resources.find((resource) => {
                    return resource.id === resource_id;
                });
                if (resource) {
                    _resources.push(resource.name);
                }
            });
            component.appointmentTypes.forEach((appointmentType_id, i) => {
                let appointmentType = apptypes.find((appointmentType) => appointmentType.id === appointmentType_id);
                if (appointmentType) {
                    if (i === 0) {
                        // use the image of the first apptype
                        let imageUrl = appointmentType.image.startsWith('https')
                            ? `${appointmentType.image}`
                            : `${ConfigHolder.apiBaseUrl}${appointmentType.image}`;
                        setApptypeImage(imageUrl);
                    }
                    _apptypes.push(appointmentType.name);
                }
            });
            setApptypeStr(_apptypes.join(', '));
            setResourceStr(_resources.join(', '));
            if (selectedCapacity > 1) {
                if (selectedCapacityGroups[0]) {
                    setCapacityStr(ts('%capacity% personen', { capacity: selectedCapacity.toString() }, 'summary'));
                }
                else {
                    let parts = [];
                    const view = flow.views.find((view) => {
                        var _a;
                        const groups = (_a = view === null || view === void 0 ? void 0 : view.components) === null || _a === void 0 ? void 0 : _a.find((component) => {
                            if (component.picker === 'capacity') {
                                return component.config.groups;
                            }
                            return undefined;
                        });
                        return groups === null || groups === void 0 ? void 0 : groups.config.groups;
                    });
                    const groups = (_b = view === null || view === void 0 ? void 0 : view.components) === null || _b === void 0 ? void 0 : _b.find((component) => {
                        if (component.picker === 'capacity') {
                            return component.config.groups;
                        }
                        return undefined;
                    });
                    for (const [_key, _value] of Object.entries(selectedCapacityGroups)) {
                        if (_key !== '0' && _value > 0) {
                            let groupName = groups === null || groups === void 0 ? void 0 : groups.config.groups.find((group) => group.id === parseInt(_key)).name;
                            parts.push(ts('%capacity% %groupName%', { capacity: _value, groupName: t(groupName, 'select') }, 'summary'));
                        }
                    }
                    setCapacityStr(parts.join(', '));
                }
            }
            else {
                setCapacityStr('');
            }
            if (appointment.price > 0) {
                setTotalPriceStr(moneyFormat(appointment.price));
            }
            else {
                setTotalPriceStr('');
            }
        }
    }, [apptypes, resources, selectedCapacityGroups, selectedCapacity]);
    useEffect(() => {
        var _a;
        let total = 0;
        cart.lines.forEach((line) => {
            var _a;
            if (line.productType !== "appointment" && !(line.productType === "subscription" && ((_a = booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0)) {
                total += line.price * line.quantity;
            }
        });
        if (((_a = booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            booking.appointments.map((appointment) => {
                total += appointment.price;
            });
        }
        setInvoiceTotal(total);
    }, [cart.lines, booking.appointments]);
    useEffect(() => {
        if (cart.lines) {
            setHasDeletables(!!(cart.lines.find((line) => { var _a; return line.origin !== "requiredPurchase" && line.productType !== "appointment" && !(line.productType === "subscription" && ((_a = booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0); })));
            if (cart.lines.length !== oldLines.length) {
                const element = document.getElementById('widget-cart-simple');
                if (element) {
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        // @ts-ignore
                        container: 'nearest'
                    });
                }
            }
            setOldLines(cart.lines);
        }
        else {
            setHasDeletables(false);
        }
    }, [cart.lines]);
    const handleRowClick = () => { };
    const handleDeleteLine = (e) => {
        let productId = parseInt(e.target.closest('button').getAttribute('rel'));
        if (productId > 0) {
            let product = getProduct(productId);
            if (product) {
                if (product && props.selectCallback) {
                    props.selectCallback(product);
                }
                if (product.trackStock) { // explicitly not undefined
                    let _lineItem = cart.lines.find((line) => line.productId === productId);
                    let _products = products.map((_product) => {
                        if (_product.id === productId && _product.trackStock) {
                            _product.stock = _lineItem === null || _lineItem === void 0 ? void 0 : _lineItem.quantity;
                        }
                        return _product;
                    });
                    setProducts(_products);
                }
                setCart(Object.assign(Object.assign({}, cart), { lines: cart.lines.filter(a => a.productId !== productId &&
                        a.requiredBy !== productId) }));
            }
        }
    };
    const onChangeQuantity = (value, name) => {
        let line = cart.lines.find((line) => parseInt(name) === line.productId);
        if (line) {
            let _lines = [];
            let diff = value - line.quantity; // can be +1 or -1 when using the buttons, or any integer if the text input is used
            let _products = products.map((_product) => {
                if (_product.id === (line === null || line === void 0 ? void 0 : line.productId) && _product.trackStock) {
                    _product.stock = _product.stock - diff; // a positive change requires a substraction
                }
                return _product;
            });
            setProducts(_products);
            cart.lines.forEach((line) => {
                if (line.productId === parseInt(name)) {
                    line.quantity = value;
                }
                _lines.push(line);
            });
            setCart(Object.assign(Object.assign({}, cart), { lines: _lines }));
            // const element = document.getElementById('widget-cart-simple')
            // if (element) {
            //     element.scrollIntoView({
            //         behavior: 'smooth',
            //         block: 'start',
            //         // @ts-ignore
            //         container: 'nearest'
            //     })
            // }
        }
    };
    const goTo = (e) => {
        let target = e.target.closest('button');
        let path = target.getAttribute('rel');
        navigate(`/oa_widget_${path}`);
    };
    const renderLine = (line, product, i) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (!product) {
            return (_jsx(Fragment, {}, i));
        }
        let imageUrl = product.image.startsWith('https')
            ? `${product.image}`
            : `${ConfigHolder.apiBaseUrl}${product.image}`;
        return (_jsxs(Fragment, { children: [_jsxs(TableRow, { rel: i.toString(), onClick: handleRowClick, sx: {
                        backgroundColor: theme.palette.background.default,
                        height: '90px',
                        maxHeight: '90px'
                    }, children: [!imageUrl.includes('missing') && (_jsx(TableCell, { sx: {
                                //width: '64px' 
                                padding: '6px',
                                width: smallMode ? '80px' : '3em',
                                maxWidth: smallMode ? '80px' : '3em'
                            }, children: _jsx(Box, { children: _jsx("img", { src: `${imageUrl}?w=350&fit=scale`, title: product.name, style: {
                                        // width: '64px',
                                        maxWidth: '64px',
                                        maxHeight: '6em'
                                    } }) }) })), _jsxs(TableCell, { colSpan: smallMode ? 4 : 1, sx: Object.assign({}, (smallMode && {
                                maxWidth: '200px',
                            })), children: [_jsx(Typography, { gutterBottom: true, variant: "h5", component: "div", sx: Object.assign(Object.assign({ fontSize: '1rem', overflow: 'hidden' }, (smallMode && {
                                        maxWidth: '200px',
                                    })), { textOverflow: "ellipsis", whiteSpace: "nowrap" }), children: line.name }), product.subtitle && (_jsx(Typography, { variant: "body2", sx: Object.assign({ color: 'text.secondary', overflow: 'hidden', 
                                        // maxWidth: '150px',
                                        textOverflow: "ellipsis", whiteSpace: "nowrap" }, (smallMode && {
                                        maxWidth: '200px',
                                    })), children: product.subtitle }))] }), !smallMode && (_jsxs(_Fragment, { children: [_jsx(StyledTableCell, { sx: {
                                        width: '8em',
                                        maxWidth: '10em',
                                        minWidth: '8em'
                                        // width: '5em'
                                    }, children: line.productType === 'product' && line.origin !== "requiredPurchase" && !["summary"].includes((_c = (_b = (_a = flow.currentView) === null || _a === void 0 ? void 0 : _a.route) === null || _b === void 0 ? void 0 : _b.route) !== null && _c !== void 0 ? _c : "") && (_jsx(Box, { children: _jsx(NumberSpinnerField, { product: product, max: product.trackStock ? (product.stock + line.quantity) : 99, name: line.productId, defaultValue: line.quantity, min: 1, onChange: onChangeQuantity }) })) }), _jsx(StyledTableCell, { sx: { width: '4em' }, children: moneyFormat(line.quantity * line.price) }), hasDeletables && (_jsx(TableCell, { sx: { width: '2em' }, align: "right", children: line.origin !== "requiredPurchase" && !["summary"].includes((_f = (_e = (_d = flow.currentView) === null || _d === void 0 ? void 0 : _d.route) === null || _e === void 0 ? void 0 : _e.route) !== null && _f !== void 0 ? _f : "") && (_jsx(IconButton, { onClick: handleDeleteLine, rel: `${line.productId}`, "aria-label": "edit", size: "medium", children: _jsx(DeleteIcon, { sx: { color: theme.palette.text.secondary } }) })) }))] }))] }, line.name), smallMode && (_jsx(TableRow, { rel: i.toString(), onClick: handleRowClick, sx: {
                        backgroundColor: theme.palette.background.default
                    }, children: _jsxs(_Fragment, { children: [_jsxs(StyledTableCell, { colSpan: 4, sx: { width: '8em', maxWidth: '10em', textAlign: 'left', fontSize: '1.25rem', fontWeight: 'bolder' }, children: [line.productType === 'product' && line.origin !== "requiredPurchase" && !["summary"].includes((_j = (_h = (_g = flow.currentView) === null || _g === void 0 ? void 0 : _g.route) === null || _h === void 0 ? void 0 : _h.route) !== null && _j !== void 0 ? _j : "") && (_jsx(NumberSpinnerField, { product: product, max: product.trackStock ? (product.stock + line.quantity) : 99, name: line.productId, defaultValue: line.quantity, min: 1, onChange: onChangeQuantity })), line.origin !== "requiredPurchase" && !["summary"].includes((_m = (_l = (_k = flow.currentView) === null || _k === void 0 ? void 0 : _k.route) === null || _l === void 0 ? void 0 : _l.route) !== null && _m !== void 0 ? _m : "") && (_jsx(IconButton, { onClick: handleDeleteLine, rel: `${line.productId}`, "aria-label": "edit", size: "medium", children: _jsx(DeleteIcon, { sx: { color: theme.palette.text.secondary } }) }))] }), _jsx(TableCell, { sx: {
                                    textAlign: "right"
                                }, children: _jsx(Box, { sx: { marginLeft: 1, display: 'inline-block' }, children: moneyFormat(line.quantity * line.price) }) })] }) }, `${line.name}_edit`)), (_o = cart.lines) === null || _o === void 0 ? void 0 : _o.map((requiredLine, j) => {
                    // let product = getProduct(requiredLine.productId)
                    if (requiredLine.origin !== "requiredPurchase" || requiredLine.requiredBy !== line.productId) {
                        return (_jsx(Fragment, {}, `${i}_${j}`));
                    }
                    return (_jsxs(TableRow, { sx: {
                            backgroundColor: theme.palette.background.default,
                            height: '32px',
                            maxHeight: '32px'
                        }, children: [_jsx(TableCell, {}), _jsxs(TableCell, { colSpan: smallMode ? 3 : 2, sx: Object.assign({ 
                                    // maxWidth: '240px',
                                    textOverflow: 'ellipsis', overflow: 'hidden' }, (isDesktop && {
                                // whiteSpace: 'nowrap'
                                })), children: [" ", requiredLine.name] }), _jsx(StyledTableCell, { children: moneyFormat(requiredLine.price) }), !smallMode && (_jsx(TableCell, {}))] }, `${i}_${j}`));
                })] }, line.productId));
    };
    return (_jsx(_Fragment, { children: _jsx(TableContainer, { id: "widget-cart-simple", sx: {
                marginBottom: 4,
                borderRadius: (props === null || props === void 0 ? void 0 : props.cartSummary) ? '0 0 4px 4px' : '4px',
                // overflowX: 'hidden'
            }, component: Paper, children: _jsx(Table, { size: "small", "aria-label": t('Overzicht van je winkelwagen'), children: _jsxs(TableBody, { sx: {
                        "& .MuiTableCell-body": {
                            fontSize: '1rem'
                        }
                    }, children: [((_a = booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0 && (_jsxs(_Fragment, { children: [_jsx(TableRow, { sx: {
                                        backgroundColor: theme.palette.background.default
                                    }, children: _jsx(TableCell, { colSpan: smallMode ? 6 : 5, children: _jsxs(Typography, { variant: "h5", sx: {
                                                fontWeight: 500,
                                                fontSize: '1.1rem',
                                                marginTop: 1,
                                                position: "relative"
                                            }, children: [t(multipleAppointments && ((_b = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _b === void 0 ? void 0 : _b.length) > 1 ? "Jouw afspraken" : "Jouw afspraak"), smallMode && (_jsx(IconButton, { onClick: goTo, rel: 'index', "aria-label": "edit", size: "medium", sx: {
                                                        position: "absolute",
                                                        top: "-8px",
                                                        right: "-16px"
                                                    }, children: _jsx(EditIcon, { sx: { color: theme.palette.text.secondary } }) }))] }) }) }, "appointment-line-1"), _jsxs(TableRow, { rel: "appointment", onClick: handleRowClick, sx: {
                                        backgroundColor: theme.palette.background.default,
                                        height: '90px',
                                        maxHeight: '90px'
                                    }, children: [!(apptypeImage === null || apptypeImage === void 0 ? void 0 : apptypeImage.toLowerCase().includes('missing')) && (_jsx(TableCell, { sx: Object.assign({ 
                                                // width: '64px', 
                                                padding: '6px' }, (multipleAppointments && ((_c = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _c === void 0 ? void 0 : _c.length) > 1 && {
                                                borderBottom: 'none'
                                            })), children: _jsx(Box, { children: _jsx("img", { src: `${apptypeImage}?w=350&fit=scale`, title: apptypeStr, style: {
                                                        width: '64px'
                                                    } }) }) })), _jsxs(TableCell, { colSpan: !(apptypeImage === null || apptypeImage === void 0 ? void 0 : apptypeImage.toLowerCase().includes('missing'))
                                                ? (smallMode
                                                    ? 3
                                                    : 2)
                                                : (smallMode
                                                    ? 4
                                                    : 3), sx: Object.assign(Object.assign({ 
                                                // maxWidth: '240px',
                                                textOverflow: 'ellipsis', overflow: 'hidden' }, (isDesktop && {
                                            // whiteSpace: 'nowrap'
                                            })), (multipleAppointments && ((_d = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _d === void 0 ? void 0 : _d.length) > 1 && {
                                                borderBottom: 'none'
                                            })), children: [_jsx(Typography, { gutterBottom: true, variant: "h5", component: "div", sx: { fontSize: '1rem' }, children: apptypeStr }), !multipleAppointments && (_jsx(Typography, { variant: "body2", sx: { color: 'text.secondary', marginBottom: '0.35em' }, children: date })), showSelectedResource && resourceStr !== '' && (_jsx(Typography, { variant: "body2", sx: { color: 'text.secondary' }, children: resourceStr })), capacityStr !== '' && (_jsx(Typography, { variant: "body2", sx: { color: 'text.secondary' }, children: capacityStr }))] }), _jsx(StyledTableCell, { sx: Object.assign({ width: '2em' }, (multipleAppointments && ((_e = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _e === void 0 ? void 0 : _e.length) > 1 && {
                                                borderBottom: 'none'
                                            })), children: multipleAppointments && ((_f = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _f === void 0 ? void 0 : _f.length) > 1 ? '' : totalPriceStr }), !smallMode && (_jsx(_Fragment, { children: _jsx(TableCell, { sx: { width: '2em' }, align: "right", children: _jsx(IconButton, { onClick: goTo, rel: 'index', "aria-label": "edit", size: "medium", children: _jsx(EditIcon, { sx: { color: theme.palette.text.secondary } }) }) }) }))] }, "appointment-line-2"), multipleAppointments && (_jsx(_Fragment, { children: booking.appointments.map((appointment, i) => {
                                        var _a;
                                        return (_jsxs(TableRow, { sx: {
                                                backgroundColor: theme.palette.background.default,
                                                "& td": Object.assign({}, (multipleAppointments && ((_a = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 1 && {
                                                    borderBottom: 'none'
                                                }))
                                            }, children: [_jsx(TableCell, {}), _jsx(TableCell, { colSpan: 3, children: _jsx(Typography, { variant: "h5", sx: { fontSize: '1rem', marginBottom: '0.35em' }, children: dayjs(appointment.date).locale(language).format('dddd D MMMM HH:mm') }, i) }), _jsx(TableCell, { sx: { width: '4em' }, align: "right", children: moneyFormat(appointment.price) })] }, `appointment-${i}`));
                                    }) })), (_g = cart.lines) === null || _g === void 0 ? void 0 : _g.map((line, j) => {
                                    let product = getProduct(line.productId);
                                    if (line.origin !== "requiredPurchase" || line.requiredBy !== "appointment") {
                                        return (_jsx(Fragment, {}, `appointment_${j}`));
                                    }
                                    return (_jsxs(TableRow, { sx: {
                                            backgroundColor: theme.palette.background.default,
                                            height: '32px',
                                            maxHeight: '32px'
                                        }, children: [!(apptypeImage === null || apptypeImage === void 0 ? void 0 : apptypeImage.toLowerCase().includes('missing')) && (_jsx(TableCell, {})), _jsxs(TableCell, { colSpan: !(apptypeImage === null || apptypeImage === void 0 ? void 0 : apptypeImage.toLowerCase().includes('missing'))
                                                    ? (smallMode
                                                        ? 3
                                                        : 2)
                                                    : (smallMode
                                                        ? 4
                                                        : 3), sx: Object.assign({ 
                                                    // maxWidth: '240px',
                                                    textOverflow: 'ellipsis', overflow: 'hidden' }, (isDesktop && {
                                                // whiteSpace: 'nowrap'
                                                })), children: [" ", line.name] }), _jsx(StyledTableCell, { children: moneyFormat(line.price) }), !smallMode && (_jsx(TableCell, {}))] }, `appointment_${j}`));
                                }), hasDeletables && (_jsx(TableRow, { sx: {
                                        backgroundColor: theme.palette.background.default
                                    }, children: _jsx(TableCell, { colSpan: smallMode ? 6 : 5, children: _jsxs(Typography, { variant: "h5", sx: {
                                                fontWeight: 500,
                                                fontSize: '1.1rem',
                                                marginTop: 2,
                                                position: "relative"
                                            }, children: [t("Extra producten"), ["summary"].includes((_k = (_j = (_h = flow.currentView) === null || _h === void 0 ? void 0 : _h.route) === null || _j === void 0 ? void 0 : _j.route) !== null && _k !== void 0 ? _k : "") && (_jsx(IconButton, { onClick: goTo, rel: 'shoppingCart', "aria-label": "edit", size: "medium", sx: {
                                                        position: "absolute",
                                                        top: smallMode ? "-8px" : "-16px",
                                                        right: smallMode ? "-16px" : "0"
                                                    }, children: _jsx(EditIcon, { sx: { color: theme.palette.text.secondary } }) }))] }) }) }, "appointment-line-3"))] })), ((_m = (_l = booking.appointments) === null || _l === void 0 ? void 0 : _l.length) !== null && _m !== void 0 ? _m : 0) === 0 && (_jsx(_Fragment, { children: hasDeletables && (_jsx(TableRow, { sx: {
                                    backgroundColor: theme.palette.background.default
                                }, children: _jsx(TableCell, { colSpan: smallMode ? 6 : 5, children: _jsxs(Typography, { variant: "h5", sx: {
                                            fontWeight: 500,
                                            fontSize: '1.1rem',
                                            marginTop: 2,
                                            position: "relative"
                                        }, children: [t("Jouw winkelwagen"), ["summary"].includes((_q = (_p = (_o = flow.currentView) === null || _o === void 0 ? void 0 : _o.route) === null || _p === void 0 ? void 0 : _p.route) !== null && _q !== void 0 ? _q : "") && (_jsx(IconButton, { onClick: goTo, rel: 'shoppingCart', "aria-label": "edit", size: "medium", sx: {
                                                    position: "absolute",
                                                    top: smallMode ? "-8px" : "-16px",
                                                    right: smallMode ? "-16px" : "0"
                                                }, children: _jsx(EditIcon, { sx: { color: theme.palette.text.secondary } }) }))] }) }) }, "appointment-line-4")) })), (_r = cart.lines) === null || _r === void 0 ? void 0 : _r.map((line, i) => {
                            let product = getProduct(line.productId);
                            if (line.origin === "requiredPurchase") {
                                return (_jsx(Fragment, {}, `${line.productId}_${i}`));
                            }
                            return (_jsx(Fragment, { children: renderLine(line, product, i) }, `${line.productId}_${i}`));
                        }), invoiceTotal > 0 && (_jsxs(TableRow, { sx: {
                                color: theme.palette.secondary.contrastText,
                                backgroundColor: theme.palette.secondary.main,
                                height: '50px',
                                minHeight: '50px',
                            }, children: [_jsxs(TableCell, { colSpan: smallMode ? 4 : 3, sx: {
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        fontSize: '1.1rem !important'
                                    }, children: [t('Totaal'), ":"] }), _jsx(StyledTableCell, { sx: {
                                        fontWeight: 'bold',
                                        fontSize: '1.1rem !important'
                                    }, children: moneyFormat(invoiceTotal) }), !smallMode && (_jsx(TableCell, {}))] }, "total"))] }) }) }) }));
}
